import type { Menu } from '@/menus/types.ts';
export default [
  {
    code: 'VEHICLE_DELIVERY',
    icon: 'menu-vehicle-delivery',
    label: '车辆交付',
    path: '/vehicle-delivery',
    children: [
      {
        code: 'VEHICLE_DELIVERY_LIST',
        hidden: true,
        icon: 'menu-vehicle-delivery',
        label: '车辆交付',
      },
    ],
  },
  {
    code: 'VEHICLE_CANCELLATION',
    icon: 'menu-vehicle-delivery',
    label: '车辆注销',
    path: '/vehicle-delivery/cancellation',
  },
] satisfies Menu[];
